import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { RightOutline, LeftOutline, ExclamationShieldOutline } from 'antd-mobile-icons'
import { recharge2, getInfo } from '../request/api'
import QrcodeVue from 'qrcode.react'
import { Toast } from 'antd-mobile'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import './NewPay2.css'
import { useTranslation } from "react-i18next";
import { setItem, getItem } from "../utils/localStorage";

export default function NewPay() {
    const navigate = useNavigate()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)
    const payId = searchParams.get('payId')
    const [userInfo, setUserInfo] = useState({})
    const [payData, setPayData] = useState({})
    const { t, i18n } = useTranslation();

    useEffect(() => {
        if (!userInfo?.cates?.length) return

        userInfo.cates.some((v) => {
            return v.child.some((item) => {
                if (item.id == payId) {
                    setPayData((prev) => ({ ...prev, ...item, title: v.name }))
                    return true
                }
                return false
            })
        })
    }, [userInfo, payId])

    useEffect(() => {
        if (!payId) return
        let loadId = Toast.show({
            icon: 'loading',
            content: t('t4'),
            duration: 0,
        })
        recharge2({ child_id: payId }).then((res) => {
            loadId.close()
            setPayData((prev) => ({ ...prev, address: res.data }))
        })
    }, [payId])

    const handleCopy = () => {
        Toast.show({ icon: 'success', content: t('zf6') })
    }
    const getData = async () => {

        const res = await getItem("userInfo")
        setUserInfo(res)

    }
    const nodeFun = () => { }
    nodeFun()
    useEffect(() => {
        getData()
    }, [])
    return (
        <div className="pay-page3">
            <div className='header'>
                <div className='backIcon' onClick={() => { navigate(-1) }}>
                    <LeftOutline />
                </div>
                <p>{payData.title}({payData.name})</p>
            </div>
            <p className="msg">
                {t('zf8')} {payData.title}({payData.name}) {t('zf9')}
            </p>
            <div className="box-con">
                <p className="name">{t('zf10')}</p>
                <p className="icon-box">
                    <img src={payData.image} alt="icon" />
                    <span>{payData.name}</span>
                </p>
                <div className="erweima-box">
                    {payData.address && <QrcodeVue value={payData.address} size={200} level="H" />}
                </div>
                <div className="dizhi">
                    <div className="lf">{payData.address}</div>
                    <CopyToClipboard text={payData.address} onCopy={handleCopy}>
                        <div className="rg">{t('zf11')}</div>
                    </CopyToClipboard>
                </div>
                <p className="info">
                    <ExclamationShieldOutline className="icon" />
                    {t('zf12')}
                </p>
                <div className="item">
                    <div className="lf">{t('zf13')}</div>
                    <div className="rg">{t('zf14')}</div>
                </div>
                <div className="item">
                    <div className="lf">{t('zf15')}</div>
                    <div className="rg">1{payData.name}</div>
                </div>
            </div>
        </div>
    )
}
